import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { IngredientImage } from './ingredientImage';


export function YourIngredients(ingredients){
   console.log(ingredients.ingredients)
      return (
        <View style={styles.ingredientContainer}>
          <Text style={styles.yourIngredients}>Your Ingredients</Text>
          <View style={styles.ingredientImages}>
          <IngredientImage ingredient={ingredients.ingredients[0]}/>
          <IngredientImage ingredient={ingredients.ingredients[1]}/>
          <IngredientImage ingredient={ingredients.ingredients[2]}/>
          <IngredientImage ingredient={ingredients.ingredients[3]}/>
          <IngredientImage ingredient={ingredients.ingredients[4]}/>
          <IngredientImage ingredient={ingredients.ingredients[5]}/>
          </View>
        </View>
      );
    }
    
    const styles = StyleSheet.create({
      ingredientContainer: {
        flex: 1,
        backgroundColor: '#EFE5DA',
        justifyContent: 'center',
        alignItems: 'center',
        //width: '80%',
        width: 'fit-content',
        height: 'fit-content',
        //flex: 'wrap'
      },
      yourIngredients: {
        fontFamily: 'DM Serif Display',
        fontSize: 30,
        fontWeight: 'bold',
        color: '#3B1C15',
        marginTop: 10,
        marginBottom: 5,
      },
      ingredientImages: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
        justifyContent: 'space-around',
        flexWrap: 'wrap'
      },
      image: {
        width: '100%',
        height: 50,
      },
      imageLabel: {
        marginTop: 10,
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
      },
      imageDescription: {
        marginTop: 5,
        fontSize: 14,
        textAlign: 'center',
      },
    });

    